import { Linkedin, Twitter } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';

interface TeamMember {
  name: string;
  title: string;
  bio: string;
  linkedin: string;
  twitter?: string;
  image: string;
}

const teamMembers: TeamMember[] = [
  {
    name: "Nikunj Verma",
    title: "Cofounder, CEO",
    bio: "Nikunj leads the overall vision & strategy at Cutshort and enables the team with everything they need to be highly effective. Before Cutshort, Nikunj led top teams at U.S. based venture backed companies and played an instrumental role in the exit of his last startup for INR 110 crore. He has an MBA from XLRI Jamshedpur (Bronze medalist). His journey: From building culture to making sales, Nikunj has learned many vital skills while steering Cutshort.",
    linkedin: "https://linkedin.com/in/nikunjverma",
    twitter: "https://twitter.com/nikunjverma",
    image: "/lovable-uploads/4b3bea26-06d2-4efd-a04b-f6046d794008.png"
  },
  {
    name: "Anubhav Gupta",
    title: "Cofounder, CTO",
    bio: "Anubhav is a design prodigy who also happens to be a self taught fullstack engineer. An Economics graduate from Delhi University, Anubhav is the hands and brains behind all that you see / touch / feel on Cutshort. You can also catch him playing the keys in an ambient-prog-rock band, Celestial Teapot. His journey: Since having worked on 2 startups while in college, Anubhav has developed a knack for designing and building world class products.",
    linkedin: "https://linkedin.com/in/anubhavgupta",
    image: "/lovable-uploads/4b3bea26-06d2-4efd-a04b-f6046d794008.png"
  },
  {
    name: "Neha Verma",
    title: "Sales evangelist",
    bio: "With 9 years of hands-on experience at various startups & enterprises such as Future Group, Neha leads Customer Success at Cutshort. She is a gifted multitasker and artfully balances many moving things on the go, including the tantrums of her newborn. Her journey: Neha came in from a non technical + marketing background. Today, not only she has learned product and customer success skills, but can also debug technical issues in a jiffy.",
    linkedin: "https://linkedin.com/in/nehaverma",
    image: "/lovable-uploads/4b3bea26-06d2-4efd-a04b-f6046d794008.png"
  },
  {
    name: "Anupran Trivedi",
    title: "Customer success & Sales evangelist",
    bio: "An ex-CEO at an IoT startup that raised funds and posted INR 1.5Cr in revenue, Anupran is a Product person with a knack in analytics and customer engagement. He loves animals (snakes are his favorite!) and has a pet Beagle named Peanut! His journey: Anupran realized the mistakes his previous startup made in key areas like building products & building culture and has picked strong competencies across a diverse set of areas.",
    linkedin: "https://linkedin.com/in/anuprantrivedi",
    image: "/lovable-uploads/4b3bea26-06d2-4efd-a04b-f6046d794008.png"
  },
  {
    name: "Sweta Agarwal",
    title: "Account Management & Sales",
    bio: "A Yoga teacher, a number geek and a customer advocate, Sweta breaks many typical stereotypes. She may be the youngest member in the Account Management team, but often comes up with insights and suggestions that experienced folks miss. Her journey: Sweta started as a fresher who is hungry to grow fast. In a short span, she has picked up valuable lessons on how to manage customers at scale with data insights, prioritization and automation.",
    linkedin: "https://linkedin.com/in/swetaagarwal",
    image: "/lovable-uploads/4b3bea26-06d2-4efd-a04b-f6046d794008.png"
  },
  {
    name: "Prakhar Jain",
    title: "Business intelligence",
    bio: "A compassionate vegan on a mission to create a better world for animals, Prakhar started as an SDR and has now become an integral part of the Growth and Intelligence Team, enabling the business team and facilitating seamless operations while spearheading the GTM and ABM strategy execution. Beyond his professional endeavors, he has a passion for travel and enjoys playing squash. He dreams of becoming a wildlife conservationist and photographer, driven by a deep passion for preserving the beauty of our natural world.",
    linkedin: "https://linkedin.com/in/prakharjain",
    image: "/lovable-uploads/4b3bea26-06d2-4efd-a04b-f6046d794008.png"
  },
  {
    name: "Noel Grewal",
    title: "Sales evangelist",
    bio: "She is water. Swiftly molding and taking shape of the places and situations she is put into. She is an executioner and a true believer of the human potential. With an ever flowing love for good food, breathtaking views and Iced Tea.",
    linkedin: "https://linkedin.com/in/noelgrewal",
    image: "/lovable-uploads/4b3bea26-06d2-4efd-a04b-f6046d794008.png"
  },
];

export const TeamSection = () => {
  return (
    <div className="mb-20">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {teamMembers.map((member) => (
          <Card key={member.name} className="hover:shadow-lg transition-shadow duration-300">
            <CardContent className="p-6">
              <div className="flex items-center gap-4 mb-4">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-16 h-16 rounded-full object-cover"
                />
                <div>
                  <h3 className="font-semibold text-xl text-brand-darkgrey">{member.name}</h3>
                  <p className="text-brand-grey">{member.title}</p>
                </div>
              </div>
              <p className="text-brand-grey mb-4">{member.bio}</p>
              <div className="flex gap-3">
                <a
                  href={member.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-brand-blue hover:text-brand-blue/80"
                >
                  <Linkedin className="w-5 h-5" />
                </a>
                {member.twitter && (
                  <a
                    href={member.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-brand-blue hover:text-brand-blue/80"
                  >
                    <Twitter className="w-5 h-5" />
                  </a>
                )}
              </div>
            </CardContent>
          </Card>
        ))}
      </div>
    </div>
  );
};
